import { colorTextoBanner, fondoBanner, type BannerClinica as Banner } from "../../../dominio/src/index.ts";
import { Logo } from "../pantallas/comun.tsx";

/**
 * Banner de la clínica: logotipo a la izquierda, nombre grande y «With Donna» abajo a la derecha, sobre el color (o degradado)
 * que eligió el administrador. Sin logotipo se muestra el diente de Donna.
 */
export function BannerClinica({ nombre, logo, banner, alCargarLogoRoto }: { nombre: string; logo: string | null; banner: Banner; alCargarLogoRoto?: () => void }) {
  const texto = colorTextoBanner(banner);
  return (
    <div className="banner-clinica" style={{ background: fondoBanner(banner), color: texto }} role="img" aria-label={`${nombre}, With Donna`}>
      <div className="banner-logo" aria-hidden="true">
        {logo ? <img src={logo} alt="" onError={alCargarLogoRoto} /> : <Logo />}
      </div>
      <span className="banner-nombre" aria-hidden="true">{nombre}</span>
      <span className="banner-by" aria-hidden="true">With Donna</span>
    </div>
  );
}
